var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListenToRecordingImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4439 6.15347L9.17231 8.52726H6.19851C5.88064 8.52726 5.5758 8.65133 5.35103 8.87217C5.12627 9.09301 5 9.39254 5 9.70486V14.6801C5 14.9924 5.12627 15.2919 5.35103 15.5128C5.5758 15.7336 5.88064 15.8577 6.19851 15.8577H9.17231L13.4439 18.2315C13.626 18.3332 13.8322 18.3861 14.0416 18.3849C14.2511 18.3837 14.4566 18.3285 14.6376 18.2248C14.8185 18.1211 14.9686 17.9725 15.0727 17.7939C15.1769 17.6153 15.2315 17.413 15.231 17.2072V7.17777C15.2315 6.97194 15.1769 6.7696 15.0727 6.591C14.9686 6.4124 14.8185 6.26381 14.6376 6.1601C14.4566 6.05638 14.2511 6.00118 14.0416 6.00002C13.8322 5.99886 13.626 6.05177 13.4439 6.15347Z",
    fill: "#6E6E6E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8995 16.2312L16.3385 15.1904C16.8151 14.8827 17.2096 14.4434 17.4827 13.9163C17.7558 13.3891 17.8979 12.7927 17.8947 12.1866C17.8916 11.5804 17.7434 10.9858 17.4649 10.4621C17.1864 9.93838 16.7873 9.50394 16.3076 9.20218L16.8598 8.15411C17.5068 8.56124 18.045 9.14735 18.4206 9.85385C18.7961 10.5604 18.9959 11.3625 18.9999 12.1801C19.004 12.9978 18.8121 13.8022 18.4435 14.5131C18.0749 15.2241 17.5425 15.8165 16.8995 16.2312Z",
    fill: "#6E6E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListenToRecordingImg);
export default __webpack_public_path__ + "static/media/listen_to_recording_img.9524319d4ab24a41829607b64381eb7c.svg";
export { ForwardRef as ReactComponent };